import { render, staticRenderFns } from "./IprView.vue?vue&type=template&id=5ff738db"
import script from "./IprView.vue?vue&type=script&lang=js"
export * from "./IprView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports